import React from 'react';
import {TimePicker} from '@mui/x-date-pickers/TimePicker';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {Dayjs} from 'dayjs';
import {t} from 'i18next';

interface IAurTimePickerProps {
  placeholder?: string;
  value?: Dayjs;
  format?: string;
  views?: Array<'hours' | 'minutes' | 'seconds'>;
  disabled?: boolean;
  onAccept?: (time?: Dayjs) => void;
}

const AurTimePicker: React.FC<IAurTimePickerProps> = ({
  placeholder = t('common.timePicker.selectTimePlaceholder'),
  value,
  format = 'HH:mm:ss',
  views = ['hours', 'minutes', 'seconds'],
  disabled = false,
  onAccept,
}) => {
  const handleOnAccept = (newTime: any) => {
    if (onAccept) {
      onAccept?.(newTime.isValid() ? newTime : undefined);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        className={
          disabled
            ? 'aur-time-picker aur-time-picker-disabled'
            : 'aur-time-picker'
        }
        label={placeholder}
        value={value}
        format={format}
        onAccept={handleOnAccept}
        onChange={handleOnAccept}
        disabled={disabled}
        views={views}
        slotProps={{
          textField: {
            inputProps: {
              'data-testid': 'time-picker',
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default AurTimePicker;
